import React from 'react';

/**
 * Composant d'illustrations SVG modernes pour le dashboard
 * Toutes les illustrations sont optimisées et responsive
 */

// Illustration pour état vide - Pas de liens
export const EmptyLinksIllustration = ({ width = 300, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Aucun lien créé"
  >
    <defs>
      <linearGradient id="emptyLinksGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066FF" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#00D4FF" stopOpacity="0.05" />
      </linearGradient>
    </defs>
    <rect width="300" height="200" fill="url(#emptyLinksGradient)" rx="12" />
    <g opacity="0.6">
      <path
        d="M150 60C150 60 130 80 130 100C130 120 150 140 150 140"
        stroke="#0066FF"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <path
        d="M150 140C150 140 170 120 170 100C170 80 150 60 150 60"
        stroke="#0066FF"
        strokeWidth="3"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="130" cy="100" r="8" fill="#0066FF" opacity="0.3" />
      <circle cx="170" cy="100" r="8" fill="#0066FF" opacity="0.3" />
      <circle cx="150" cy="60" r="12" fill="#0066FF" opacity="0.2" />
      <circle cx="150" cy="140" r="12" fill="#0066FF" opacity="0.2" />
    </g>
    <path
      d="M100 160L200 160"
      stroke="#0066FF"
      strokeWidth="2"
      strokeDasharray="5 5"
      opacity="0.4"
    />
  </svg>
);

// Illustration pour état vide - Pas de sessions
export const EmptySessionsIllustration = ({ width = 300, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Aucune session"
  >
    <defs>
      <linearGradient id="emptySessionsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#3B82F6" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#0066FF" stopOpacity="0.05" />
      </linearGradient>
    </defs>
    <rect width="300" height="200" fill="url(#emptySessionsGradient)" rx="12" />
    <g opacity="0.6">
      <rect x="100" y="70" width="100" height="60" rx="8" stroke="#3B82F6" strokeWidth="2" fill="none" />
      <circle cx="120" cy="100" r="8" fill="#3B82F6" opacity="0.3" />
      <circle cx="180" cy="100" r="8" fill="#3B82F6" opacity="0.3" />
      <path
        d="M100 70L150 50L200 70"
        stroke="#3B82F6"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </g>
    <path
      d="M80 150L220 150"
      stroke="#3B82F6"
      strokeWidth="2"
      strokeDasharray="5 5"
      opacity="0.4"
    />
  </svg>
);

// Illustration pour état vide - Pas de données statistiques
export const EmptyStatsIllustration = ({ width = 300, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Aucune statistique"
  >
    <defs>
      <linearGradient id="emptyStatsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" stopOpacity="0.1" />
        <stop offset="100%" stopColor="#0066FF" stopOpacity="0.05" />
      </linearGradient>
    </defs>
    <rect width="300" height="200" fill="url(#emptyStatsGradient)" rx="12" />
    <g opacity="0.6">
      <rect x="80" y="120" width="20" height="40" rx="4" fill="#10B981" opacity="0.3" />
      <rect x="110" y="100" width="20" height="60" rx="4" fill="#10B981" opacity="0.3" />
      <rect x="140" y="80" width="20" height="80" rx="4" fill="#10B981" opacity="0.3" />
      <rect x="170" y="110" width="20" height="50" rx="4" fill="#10B981" opacity="0.3" />
      <rect x="200" y="90" width="20" height="70" rx="4" fill="#10B981" opacity="0.3" />
      <path
        d="M90 160L130 140L150 120L180 150L210 130"
        stroke="#10B981"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
    </g>
  </svg>
);

// Illustration pour la section "Démarrage rapide"
export const QuickStartIllustration = ({ width = 400, height = 300, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 400 300"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Démarrage rapide"
  >
    <defs>
      <linearGradient id="quickStartGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066FF" stopOpacity="0.15" />
        <stop offset="100%" stopColor="#00D4FF" stopOpacity="0.08" />
      </linearGradient>
    </defs>
    <g opacity="0.8">
      {/* Écran de vidéo */}
      <rect x="100" y="60" width="200" height="120" rx="12" fill="white" stroke="#0066FF" strokeWidth="2" />
      <rect x="120" y="80" width="160" height="80" rx="8" fill="#0066FF" opacity="0.1" />
      <circle cx="150" cy="120" r="15" fill="#0066FF" opacity="0.2" />
      <circle cx="250" cy="120" r="15" fill="#0066FF" opacity="0.2" />
      
      {/* Flèche de connexion */}
      <path
        d="M200 200L200 240L180 240L180 220L160 220L180 200L200 200Z"
        fill="#0066FF"
        opacity="0.4"
      />
      
      {/* Lien */}
      <path
        d="M100 250L300 250"
        stroke="#0066FF"
        strokeWidth="3"
        strokeDasharray="8 4"
      />
      <circle cx="100" cy="250" r="6" fill="#0066FF" />
      <circle cx="300" cy="250" r="6" fill="#0066FF" />
      
      {/* Icônes de partage */}
      <g transform="translate(50, 240)">
        <circle r="12" fill="#0066FF" opacity="0.2" />
        <path d="M-4 0L4 0M0 -4L0 4" stroke="#0066FF" strokeWidth="2" />
      </g>
      <g transform="translate(350, 240)">
        <circle r="12" fill="#0066FF" opacity="0.2" />
        <path d="M-4 0L4 0M0 -4L0 4" stroke="#0066FF" strokeWidth="2" />
      </g>
    </g>
  </svg>
);

// Illustration pour succès de paiement
export const PaymentSuccessIllustration = ({ width = 200, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Paiement réussi"
  >
    <defs>
      <linearGradient id="successGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="80" fill="url(#successGradient)" opacity="0.1" />
    <circle cx="100" cy="100" r="60" stroke="url(#successGradient)" strokeWidth="4" fill="none" />
    <path
      d="M70 100L90 120L130 80"
      stroke="url(#successGradient)"
      strokeWidth="6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Illustration pour le dashboard Admin
export const AdminDashboardIllustration = ({ width = 300, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Dashboard administrateur"
  >
    <defs>
      <linearGradient id="adminGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#EF4444" stopOpacity="0.15" />
        <stop offset="100%" stopColor="#0066FF" stopOpacity="0.08" />
      </linearGradient>
    </defs>
    <rect width="300" height="200" fill="url(#adminGradient)" rx="12" />
    <g opacity="0.7">
      {/* Bouclier admin */}
      <path
        d="M150 50L120 60L100 80L100 110C100 130 120 150 150 160C180 150 200 130 200 110L200 80L180 60L150 50Z"
        stroke="#EF4444"
        strokeWidth="3"
        fill="none"
      />
      <path
        d="M150 70L130 75L120 90L120 110C120 125 135 140 150 145C165 140 180 125 180 110L180 90L170 75L150 70Z"
        fill="#EF4444"
        opacity="0.2"
      />
      
      {/* Graphiques */}
      <rect x="80" y="120" width="40" height="50" rx="4" fill="#0066FF" opacity="0.2" />
      <rect x="130" y="100" width="40" height="70" rx="4" fill="#0066FF" opacity="0.2" />
      <rect x="180" y="110" width="40" height="60" rx="4" fill="#0066FF" opacity="0.2" />
    </g>
  </svg>
);

// Illustration générique pour états vides
export const EmptyStateIllustration = ({ width = 300, height = 200, className = '', variant = 'default' }) => {
  const illustrations = {
    default: EmptyLinksIllustration,
    links: EmptyLinksIllustration,
    sessions: EmptySessionsIllustration,
    stats: EmptyStatsIllustration,
  };
  
  const Illustration = illustrations[variant] || illustrations.default;
  return <Illustration width={width} height={height} className={className} />;
};

// Illustration pour la card "Astuce du jour"
export const TipIllustration = ({ width = 150, height = 150, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 150 150"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Astuce"
  >
    <defs>
      <linearGradient id="tipGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#FCD34D" />
      </linearGradient>
    </defs>
    <circle cx="75" cy="75" r="60" fill="url(#tipGradient)" opacity="0.1" />
    <path
      d="M75 30L85 60L115 60L90 80L100 110L75 90L50 110L60 80L35 60L65 60L75 30Z"
      fill="url(#tipGradient)"
      opacity="0.6"
    />
  </svg>
);

// Illustration pour les crédits
export const CreditsIllustration = ({ width = 200, height = 200, className = '' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Crédits"
  >
    <defs>
      <linearGradient id="creditsGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#0066FF" />
        <stop offset="100%" stopColor="#00D4FF" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="100" r="70" fill="url(#creditsGradient)" opacity="0.1" />
    <rect x="60" y="80" width="80" height="50" rx="8" fill="url(#creditsGradient)" opacity="0.2" />
    <rect x="70" y="90" width="60" height="30" rx="4" fill="white" opacity="0.8" />
    <circle cx="85" cy="105" r="4" fill="url(#creditsGradient)" />
    <circle cx="100" cy="105" r="4" fill="url(#creditsGradient)" />
    <circle cx="115" cy="105" r="4" fill="url(#creditsGradient)" />
  </svg>
);

export default {
  EmptyLinksIllustration,
  EmptySessionsIllustration,
  EmptyStatsIllustration,
  QuickStartIllustration,
  PaymentSuccessIllustration,
  AdminDashboardIllustration,
  EmptyStateIllustration,
  TipIllustration,
  CreditsIllustration,
};
